'use strict'; // code from: https://hackernoon.com/role-based-authorization-in-react-c70bb7641db4

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

require("whatwg-fetch");

var _lodash = _interopRequireDefault(require("lodash"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _util = require("./lib/util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

_es6Promise.default.polyfill();

// import fetch from
var Authorisation = function Authorisation(allowedRoles, allowedProjects, renderError) {
  return function (WrappedElement, ErrorElement) {
    return /*#__PURE__*/function (_React$Component) {
      _inherits(WithAuthorization, _React$Component);

      function WithAuthorization(props) {
        var _this;

        _classCallCheck(this, WithAuthorization);

        _this = _possibleConstructorReturn(this, (WithAuthorization.__proto__ || Object.getPrototypeOf(WithAuthorization)).call(this, props)); // fetch user from backend (deliver logged in session users id, role)

        _this.state = {
          user: {
            name: '',
            role: '',
            projects: []
          },
          loaded: false
        };
        _this._isMounted = false;
        return _this;
      }

      _createClass(WithAuthorization, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          this._isMounted = true;
          fetch('/api/auth', {
            credentials: 'include'
          }).then(_fetchUtils.default.checkStatus).then(function (response) {
            // The state should not be set if the component gets unmounted before the request is processed
            if (_this2._isMounted) {
              _this2.setState(function (prev) {
                prev.loaded = true;
                prev.user.name = response.email;
                prev.user.role = response.group.name;
                prev.user.roleId = response.group.id;
                prev.user.projects = response.projects;
                return prev;
              });
            }
          }).catch(function (err) {
            void 0;
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this._isMounted = false;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$state$user = this.state.user,
              role = _this$state$user.role,
              projects = _this$state$user.projects,
              roleId = _this$state$user.roleId;
          var projectOk = _lodash.default.intersection(allowedProjects, projects).length > 0 || role === 'admin';

          if (allowedRoles.includes(role) && projectOk) {
            if ((0, _util.isReactComponent)(WrappedElement)) {
              return /*#__PURE__*/_react.default.createElement(WrappedElement, _extends({
                projects: projects,
                role: role,
                roleId: parseInt(roleId)
              }, this.props));
            }

            return WrappedElement || '';
          } else if (renderError && this.state.loaded) {
            if (ErrorElement && (0, _util.isReactComponent)(ErrorElement)) return /*#__PURE__*/_react.default.createElement(ErrorElement, this.props);
            return /*#__PURE__*/_react.default.createElement("h1", null, "Sie sind nicht autorisiert");
          }

          return null;
        }
      }]);

      return WithAuthorization;
    }(_react.default.Component);
  };
};

var _default = Authorisation;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/authorisation/index.js
// module id = 16
// module chunks = 0